import React, {Component} from 'react'

import {
  Button,
} from 'material-ui'

import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';

export default class DialogAlert extends Component{
  render(){
    const {title,content,actions,status,onClose} = this.props;
    return(
      <Dialog open={status} onRequestClose={onClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {actions.map((action,i) => <Button key={i} onClick={action.action} color="primary">{action.content}</Button>)}
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DialogAlert.js